import { render, staticRenderFns } from "./SvgGyro.vue?vue&type=template&id=09564d52&"
import script from "./SvgGyro.vue?vue&type=script&lang=js&"
export * from "./SvgGyro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports